import { render, staticRenderFns } from "./create.vue?vue&type=template&id=398b2bfc&lang=pug&"
import script from "./create.vue?vue&type=script&setup=true&lang=js&"
export * from "./create.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=398b2bfc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports